// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';

// Components
import Error from '../core/error';
import SearchTableWithSort from '../app/search-tablewithsort';
import ServicesExportPanelAction from '../app/services-export-panel-action';

// Containers
import withSearch from '../../containers/with-search';

const servicesDataKey = 'moviesAndProgramsRelated';

class MoviesAndProgramsRelated extends Component {
    getColumnConfig() {
        const detailLink = '/movies-and-programs';

        return [
            {
                dataKey: 'title',
                formatter: 'moviesAndProgramsTitle',
                link: detailLink,
                linkKey: ['echostarId', 'roviProgramId'],
                sortKey: 'title.sortable',
                title: 'Title',
                type: 'link',
                width: '17%',
            },
            {
                dataKey: 'episodeSeason',
                title: 'S',
                tooltip: 'Season Number',
                width: '5%',
            },
            {
                dataKey: 'episodeNumber',
                title: 'E',
                tooltip: 'Episode Number',
                width: '5%',
            },
            {
                dataKey: 'echostarContentType',
                title: 'Type',
                tooltip: 'Echostar Content Type',
                width: '6%',
            },
            {
                dataKey: 'echostarId',
                link: detailLink,
                linkKey: ['echostarId', 'roviProgramId'],
                title: 'E* ID',
                tooltip: 'Echostar ID',
                type: 'link',
                width: '14%',
            },
            {
                dataKey: 'description',
                title: 'Description',
                width: '34%',
            },
            {
                dataKey: 'releaseYear',
                title: 'Released',
                tooltip: 'Release Year',
                type: 'string',
                width: '7%',
            },
            {
                dataKey: 'originalAirDate',
                title: 'Original Air',
                tooltip: 'Original Air Date',
                type: 'date',
                width: '12%',
            },
        ];
    }

    getRowDetails() {
        return {
            whitelistKeys: [
                'description',
                'sportDatetime',
                'sportSeasonType',
                'episodeSeason',
                'programType',
                'genres',
                'runtime',
                'rating',
                'titleLanguages',
                'descriptionLanguage',
            ],
        };
    }

    getTablewithsortProps() {
        return {
            ...this.props,
            columnConfig: this.getColumnConfig(),
            formName: servicesDataKey,
            noPageLimit: true,
            noRecordsError: 'No associated movies & programs available.',
            noRefresh: true,
            noReset: true,
            localSort: true,
            rowDetails: this.getRowDetails(),
            servicesDataKey,
        };
    }

    render() {
        const {routerParams, searchData} = this.props;

        return routerParams.guid ? (
            <div className="movies-and-programs">
                <ServicesExportPanelAction exportConfig="moviesAndPrograms" searchData={searchData} />
                <SearchTableWithSort {...this.getTablewithsortProps()} />
            </div>
        ) : (
            <Error error="Choose a record." />
        );
    }
}

MoviesAndProgramsRelated.propTypes = {
    routerParams: PropTypes.object,
    searchData: PropTypes.array,
    tableWithSortProps: PropTypes.object,
};

export default withSearch(MoviesAndProgramsRelated, servicesDataKey);
